import React from 'react';
import { Cpu, Server, Zap, BarChart3, HardDrive, Wifi } from 'lucide-react';

function ComputeSection() {
  return (
    <div className="p-8 space-y-8">
      <div>
        <h2 className="text-3xl font-bold text-white">Compute</h2>
        <p className="text-slate-400 mt-1">Infrastructure resource overview</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="glass-panel p-6">
          <div className="flex items-center gap-3 mb-3">
            <Cpu className="w-5 h-5 text-purple-400" />
            <h3 className="text-sm font-medium text-slate-400">CPU</h3>
          </div>
          <p className="text-2xl font-bold text-white">32 cores</p>
          <div className="mt-2 h-1.5 bg-slate-800 rounded-full overflow-hidden">
            <div className="h-full w-[42%] rounded-full bg-purple-500" />
          </div>
          <p className="text-xs text-slate-500 mt-1">42% utilized</p>
        </div>

        <div className="glass-panel p-6">
          <div className="flex items-center gap-3 mb-3">
            <Zap className="w-5 h-5 text-amber-400" />
            <h3 className="text-sm font-medium text-slate-400">GPU</h3>
          </div>
          <p className="text-2xl font-bold text-white">4 units</p>
          <div className="mt-2 h-1.5 bg-slate-800 rounded-full overflow-hidden">
            <div className="h-full w-[30%] rounded-full bg-amber-500" />
          </div>
          <p className="text-xs text-slate-500 mt-1">30% utilized</p>
        </div>

        <div className="glass-panel p-6">
          <div className="flex items-center gap-3 mb-3">
            <HardDrive className="w-5 h-5 text-emerald-400" />
            <h3 className="text-sm font-medium text-slate-400">Memory</h3>
          </div>
          <p className="text-2xl font-bold text-white">32 GB</p>
          <div className="mt-2 h-1.5 bg-slate-800 rounded-full overflow-hidden">
            <div className="h-full w-[55%] rounded-full bg-emerald-500" />
          </div>
          <p className="text-xs text-slate-500 mt-1">55% utilized</p>
        </div>

        <div className="glass-panel p-6">
          <div className="flex items-center gap-3 mb-3">
            <Wifi className="w-5 h-5 text-blue-400" />
            <h3 className="text-sm font-medium text-slate-400">Network</h3>
          </div>
          <p className="text-2xl font-bold text-white">1 Gbps</p>
          <div className="mt-2 h-1.5 bg-slate-800 rounded-full overflow-hidden">
            <div className="h-full w-[18%] rounded-full bg-blue-500" />
          </div>
          <p className="text-xs text-slate-500 mt-1">18% bandwidth</p>
        </div>
      </div>
    </div>
  );
}

export default ComputeSection;
